import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useRouter } from "next/router";
import getGenerateToken from "@helpers/getGenerateToken";
import useResponsive from "@helpers/useResponsive";
import { selectSearch, setSearch } from "@redux/slices/search";
import { useAppDispatch } from "@redux/store";
import { IFilter } from "../interface";
import { getStorageToken } from "@helpers/storage";
import { useLanguage } from "@utils/useLanguage";
import { filterFaqBTN } from "../utils";
import { useAccountContext } from "@contexts/AccountProvider";

const useAction = (t: any) => {
  const { isAuth, account } = useAccountContext();
  const apiWA = "https://api.whatsapp.com/send";
  const router = useRouter();
  const dispatch = useAppDispatch();
  const mdClient = useResponsive("md");
  const { language } = useLanguage();
  const [helpdeskData, setHelpDeskData] = useState<{ phoneNumber: string; message: string }>({
    phoneNumber: "",
    message: "",
  });
  const search = useSelector(selectSearch);
  const [isModalHelpdesk, setIsModalHelpdesk] = useState<boolean>(false);

  const handleSearch = (values: string) => {
    dispatch(setSearch(values));
    if (values) {
      router.push({
        pathname: router.pathname,
        query: {
          search: values,
        },
      });
    } else {
      router.push({ query: {} });
    }
  };

  const filterData = filterFaqBTN.map((item: IFilter, idx: number) => ({
    ...item,
    title: t(`faq:topics.${idx + 1}`),
  }));

  function getDetailHelpDesk(phoneNumber: string) {
    const isComma = language === "id" ? ", " : " ";
    const upperCasedName = account.name
      .split(" ")
      .map((item: string) => item.charAt(0).toUpperCase() + item.slice(1))
      .join(" ");
    const textAfterLogin = `${
      t("waTextAfterLogin.msg_wa_1") +
      " " +
      upperCasedName +
      isComma +
      t("waTextAfterLogin.msg_wa_2")
    }`;
    setHelpDeskData({
      ...helpdeskData,
      ["phoneNumber"]: phoneNumber,
      ["message"]: isAuth ? textAfterLogin : t("waTextBeforeLogin"),
    });
  }

  async function getToken() {
    let token = "";
    getStorageToken().accessToken
      ? (token = getStorageToken().accessToken)
      : (token = await getGenerateToken());
    return token;
  }

  const onHelpdeskClick = async () => {
    setIsModalHelpdesk(true);
  };

  // ** useEffect is handling to clear query params on first load ** //
  useEffect(() => {
    dispatch(setSearch(""));
    const fetchRouter = setTimeout(() => {
      history.replaceState({}, "", router.pathname);
    }, 100);

    return () => window.clearTimeout(fetchRouter);
  }, []);

  return {
    getToken,
    getDetailHelpDesk,
    handleSearch,
    helpdeskData,
    apiWA,
    router,
    search,
    mdClient,
    isModalHelpdesk,
    setIsModalHelpdesk,
    filterData,
    language,
    onHelpdeskClick,
    isAuth,
  };
};

export default useAction;
